<section class="md:h-screen py-36 flex items-center bg-neutral-900 bg-no-repeat bg-center">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
  <div class="container">
    <div class="flex justify-center">
      <div class="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-neutral-900 shadow-md dark:shadow-neutral-900 rounded-md">
        <a [routerLink]="'/'">
          <img [src]="'assets/images/logoQuality.png'" class="mx-auto h-7 block" alt="">
        </a>

        <!-- Error message display -->
        @if (errorMessage) {
          <div class="my-4 p-3 bg-red-100 text-red-700 rounded-md">
            {{ errorMessage }}
          </div>
        }

        <!-- Login Form -->
        @if (!requireMfa) {
          <div>
            <h5 class="my-6 text-xl font-semibold">{{ 'SIGNIN.LOGIN_BOX_TITLE' | translate }}</h5>
            <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" class="text-start" autocomplete="off">
              <div class="grid grid-cols-1">
                <div class="mb-4">
                  <label class="font-semibold" for="LoginEmail">{{ 'SIGNIN.EMAIL' | translate }}:</label>
                  <input id="LoginEmail" type="email" formControlName="email" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-neutral-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="name@example.com">
                  @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
                    <div class="text-red-500 text-sm mt-1">
                      {{ 'SIGNIN.INVALID_EMAIL' | translate }}
                    </div>
                  }
                </div>
                <div class="mb-4">
                  <label class="font-semibold" for="LoginPassword">{{ 'SIGNIN.PASSWORD' | translate }}:</label>
                  <input id="LoginPassword" type="password" formControlName="password" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-neutral-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" [placeholder]="'SIGNIN.PASSWORD' | translate">
                  @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
                    <div class="text-red-500 text-sm mt-1">
                      {{ 'SIGNIN.INVALID_PASSWORD' | translate }}
                    </div>
                  }
                </div>
                <div class="flex justify-between mb-4">
                  <div class="inline-flex items-center mb-0">
                    <input class="form-checkbox rounded border-gray-200 dark:border-neutral-900 text-neutral-600 focus:border-neutral-600/30 focus:ring focus:ring-offset-0 focus:ring-neutral-600/20 focus:ring-opacity-50 me-2" type="checkbox" formControlName="rememberMe" id="RememberMe">
                    <label class="form-checkbox-label" for="RememberMe">{{ 'SIGNIN.REMEMBER_ME' | translate }}</label>
                  </div>
                  <p class="mb-0"><a [routerLink]="'/forgot-password'">{{ 'SIGNIN.FORGOT_PASSWORD' | translate }}</a></p>
                </div>
                <div class="mb-4">
                  <app-button [disabled]="loginForm.invalid" [loading]="isLoading" color="primary" rounded="full" [fullWidth]="true" [type]="'submit'">{{ 'SIGNIN.SUBMIT_LOGIN_BTN' | translate }}</app-button>
                </div>
                <div class="text-center">
                  <span class="me-2">{{ 'SIGNIN.DONT_HAVE_AN_ACCOUNT' | translate }}</span>
                </div>
              </div>
            </form>
          </div>
        }

        <!-- MFA Form -->
        @if (requireMfa) {
          <div>
            <h5 class="my-6 text-xl font-semibold">{{ 'SIGNIN.MFA_BOX_TITLE' | translate }}</h5>
            <p class="mb-4 text-neutral-500">{{ 'SIGNIN.MFA_BOX_DESC' | translate }}</p>
            <form [formGroup]="mfaForm" (ngSubmit)="onMfaSubmit()" class="text-start">
              <div class="grid grid-cols-1">
                <div class="mb-4">
                  <label class="font-semibold" for="MfaCode">{{ 'SIGNIN.VERIFICATION_CODE' | translate }}:</label>
                  <input id="MfaCode" type="text" formControlName="mfaCode" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-neutral-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="000000">
                  @if (mfaForm.get('mfaCode')?.invalid && mfaForm.get('mfaCode')?.touched) {
                    <div class="text-red-500 text-sm mt-1">
                      {{ 'SIGNIN.ENTER_VALID_CODE' | translate }}
                    </div>
                  }
                </div>
                <div class="mb-4">
                  <app-button [disabled]="mfaForm.invalid" [loading]="isLoading" color="primary" rounded="full" [fullWidth]="true" [type]="'submit'">{{ 'SIGNIN.VERIFY' | translate }}</app-button>
                </div>
                <div class="mb-4">
                  <app-button type="button" (click)="backToLogin()" rounded="full" [fullWidth]="true">
                    {{ 'SIGNIN.BACK_TO_LOGIN' | translate }}
                  </app-button>
                </div>
              </div>
            </form>
          </div>
        }
      </div>
    </div>
  </div>
</section><!--end section -->
